export const generatePastelColor = () => {
  const hue = Math.floor(Math.random() * 360);
  const saturation = 60 + Math.floor(Math.random() * 20); // Pastel colors have lower saturation
  const lightness = 80 + Math.floor(Math.random() * 10); // Pastel colors are generally lighter

  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
};
